import type { CalendarInfo } from 'models/forms/fields/DateFieldMetadata';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSettlementDateCalendars, getValuationDateCalendars } from 'state/selectors/common/misc';

const EMPTY_CALENDARS: CalendarInfo[] = [];

export function useBlackoutDates(calendars: CalendarInfo[] = EMPTY_CALENDARS) {
  const settlementDates = useSelector(getSettlementDateCalendars);
  const valuationDates = useSelector(getValuationDateCalendars);
  return useMemo(() => {
    return Array.from(
      new Set(
        calendars
          .map(({ calendarType, currency, id }) => {
            switch (calendarType) {
              case 'Settlement':
                return currency ? (settlementDates[currency] ?? []) : [];
              case 'Valuation':
                return id ? (valuationDates[id] ?? []) : [];
              default:
                return [];
            }
          })
          .reduce((agg, cur) => [...agg, ...cur], []),
      ),
    );
  }, [calendars, settlementDates, valuationDates]);
}
